import React from 'react'
import ClosedJobTable from './JobTableComponent/ClosedJobTable'



const JobClosed = ({ setClosedJob, data, isLoading, message, isError }) => {



	return (
		<div>
			<ClosedJobTable
				isLoading={isLoading}
				message={message}
				isError={isError}
				data={data}
				setClosedJob={setClosedJob}
				pageHeader={"Closed"}
				headerTitles={[
					'Jobs',
					'Openings',
					'Opening Date',
					'Expiry Date',
					'Team',
					'Location',
					'Workplace Type',
					'Recruiter Tagged',
					'Hiring Manager',
					'Closure Date',
					'Closure Reason'
				]} setActive={undefined} active={undefined} />
		</div>
	)
}

export default JobClosed